import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-181b0d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "title ws_mb20" }
const _hoisted_5 = { class: "ws_mr15" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "title ws_mb20" }
const _hoisted_8 = { class: "map-icon" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "btn ws_mt24" }

import { ref, computed, onMounted } from 'vue'
import MapModal from '@/components/map-modal-drawer'
import SubDeviceForm from './components/sub-device-form-drawer.vue'
import {
  DEVICE_DATA_UPLOAD_ENUM,
  DEVICE_LOCATION_TYPE_ENUM,
  CODE_ENUM,
  PRODUCT_TYPE,
  MAP_ICON,
} from '@/common'
import {
  queryDeviceDefaultLocation,
  deviceAdd,
  deviceDetail,
  deviceUpdate,
  querySiteTreelist,
} from '@/api'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import i18n from '@/i18n'
import { useProductStore } from '@/stores/product'
import { validateSubDevices, validateSubDevicesRequired } from '@/utils'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const productStore = useProductStore()
productStore.queryGetewayType()

const t = i18n.global.t

const router = useRouter()
const $route = useRoute()

const deviceBindId = $route.query.deviceBindId || ''

const iconList = [
  MAP_ICON.DEFAULT,
  MAP_ICON.CAR,
  MAP_ICON.SHIP,
  MAP_ICON.COW,
  MAP_ICON.FIRE,
  MAP_ICON.ANIMAL,
  MAP_ICON.PM25,
  MAP_ICON.PERSON,
  MAP_ICON.SLOPE,
]

const getClass = (i: any) => {
  const checked = i === formInline.value.picCode
  const checkedClass = checked ? `${i}-C` : ''
  return `${i} ${checkedClass}`
}

const changePicCode = (picCode: any) => {
  formInline.value.picCode = picCode
}

const devicelabelShow = computed(() => {
  return [PRODUCT_TYPE.SINGLE_GATEWAY].includes(productType.value)
})

onMounted(() => {
  if (deviceBindId) {
    queryDetail()
  } else {
    queryDefaultLocation()
  }
})

const showSubDevice = computed(() => {
  return productType.value !== PRODUCT_TYPE.LORA
})

const productType = computed(() => {
  return productStore.productGetewayType.filter(({ code }: any) => {
    return code === formInline.value.productKey
  })?.[0]?.productType
})

const baseFormRef = ref()
const confFormRef = ref()

const formInline = ref({
  deviceName: '',
  deviceSn: '',
  productKey: '',
  subDevices: [],
  locationTypeCode: DEVICE_LOCATION_TYPE_ENUM.AUTO,
  dataTypeCode: DEVICE_DATA_UPLOAD_ENUM.PROPERTIES,
  siteId: '',
  picCode: MAP_ICON.DEFAULT,
  deviceLabel: '',
})

const validatorLocation = (rule: any, value: any, callback: any) => {
  const { address, lng, lat } = mapData.value
  if (!lng || !lat) {
    callback(t('D_CREATE.msgSelect'))
  } else {
    callback()
  }
}

const validateSubDevicesMethod = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback()
    return
  } else {
    const flagList = formInline.value.subDevices.map(
      (item: any, index: number) => {
        return validateSubDevices(
          index,
          formInline.value.subDevices,
          productType.value
        )
      }
    )
    // 校验是否重复
    if (
      flagList.includes(true) ||
      validateSubDevicesRequired(formInline.value.subDevices, productType.value)
    ) {
      callback(t('D_CREATE.subErrorTip'))
    } else {
      callback()
    }
  }
}

const rules: any = {
  deviceName: { required: true, message: t('D_CREATE.deviceMsg') },
  deviceSn: { required: true, message: t('D_CREATE.deviceSnMsg') },
  address: {
    validator: validatorLocation,
  },
  // deviceLabel: [{ required: true, message: '请输入设备标签' }],
  productKey: { required: true, message: t('D_CREATE.msgSelect') },
  picCode: { required: true, message: t('D_CREATE.msgSelect') },
  subDevices: [
    // { required: true, type: 'array', message: '请选择' },
    { validator: validateSubDevicesMethod },
  ],
}

const validateForm = async (formRef: any) => {
  return new Promise((resolve: any) => {
    formRef.value.validate((valid: boolean) => {
      valid && resolve()
    })
  })
}

const loading = ref(false)
const submit = async () => {
  await Promise.all([validateForm(baseFormRef), validateForm(confFormRef)])

  let params: any = {
    deviceLabel: '',
  }
  if (formInline.value.locationTypeCode === DEVICE_LOCATION_TYPE_ENUM.HAND) {
    const { address, lng, lat } = mapData.value
    params = {
      locationAddress: address,
      locationLong: lng,
      locationLat: lat,
    }
  }
  // 单模去掉多余字段  单模才有deviceLabel
  if (productType.value === PRODUCT_TYPE.SINGLE_GATEWAY) {
    const subDevices = formInline.value.subDevices.map((item: any) => {
      return {
        ...item,
        busType: '',
        busId: '',
      }
    })
    params = {
      ...params,
      subDevices,
      deviceLabel: formInline.value.deviceLabel || '',
    }
  } else if (productType.value === PRODUCT_TYPE.LORA) {
    params = {
      ...params,
      subDevices: [],
    }
  }
  loading.value = true
  const fn = deviceBindId ? deviceUpdate : deviceAdd
  const res: any = await fn({
    ...formInline.value,
    ...params,
    deviceBindId,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg || t('D_CREATE.msgSuccess'))
    setTimeout(() => {
      router.go(-1)
    }, 800)
  }
}

const mapData: any = ref({
  address: '',
  lng: '',
  lat: '',
})
const queryDefaultLocation = async () => {
  const res: any = await queryDeviceDefaultLocation()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { deviceAddress, latitude, longitude } = res?.data || {}
    mapData.value = {
      address: deviceAddress,
      lng: longitude || '',
      lat: latitude || '',
    }
  }
}
const onMapChange = (mo: any) => {
  mapData.value = mo
  confFormRef.value.validateField('address')
}

// 切换所属产品 校验子设备
const productKeyChange = () => {
  if (formInline.value.subDevices.length) {
    baseFormRef.value.validateField('subDevices')
  }
}

const mapConf = ref({
  visible: false,
})
const toShowMap = () => {
  mapConf.value.visible = true
}

const variableConf = ref({
  visible: false,
  data: {},
})

const detailData: any = ref({})
const queryDetail = async () => {
  const res: any = await deviceDetail({
    deviceBindId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const {
      deviceLocationInfo,
      locationTypeCode,
      deviceName,
      deviceSn,
      dataTypeCode,
      productKey,
      subDevices,
      siteId,
      picCode,
      deviceLabel,
    } = res.data || {}

    detailData.value = res.data

    if (locationTypeCode === DEVICE_LOCATION_TYPE_ENUM.HAND) {
      const { deviceAddress, latitude, longitude } = deviceLocationInfo || {}
      mapData.value = {
        address: deviceAddress,
        lng: longitude || '',
        lat: latitude || '',
      }
    } else {
      queryDefaultLocation()
    }

    const subList = (subDevices || []).map(
      ({ productData, busType, busId, sensorId, deviceSnAlias }: any) => {
        const { productKey } = productData || {}
        return {
          productKey,
          busType: busType || '',
          busId: busId || '',
          sensorId,
          deviceSnAlias,
        }
      }
    )

    formInline.value = {
      deviceName,
      deviceSn,
      locationTypeCode,
      dataTypeCode,
      productKey,
      subDevices: subList,
      siteId,
      picCode,
      deviceLabel,
    }
  }
}

const subDeviceConf = ref({
  visible: false,
  data: [],
})

const toHandSubDevice = () => {
  if (!productType.value) {
    ElMessage.warning(t('D_CREATE.productMsg'))
    return
  }
  subDeviceConf.value = {
    visible: true,
    data: formInline.value.subDevices,
  }
}

const onSubDeviceChange = (subDevices: any) => {
  formInline.value.subDevices = subDevices
  baseFormRef.value.validateField('subDevices')
}

const cancel = () => {
  router.go(-1)
}

const siteTreeList: any = ref([])
const querySiteTreeList = async () => {
  const res: any = await querySiteTreelist()
  if (res?.code === CODE_ENUM.SUCCESS) {
    siteTreeList.value = res.data || []
  }
}
querySiteTreeList()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('D_CREATE.baseInfo')), 1),
          _createVNode(_component_el_form, {
            ref_key: "baseFormRef",
            ref: baseFormRef,
            class: "form-width",
            model: formInline.value,
            "label-width": 82,
            "label-position": "left",
            "hide-required-asterisk": "",
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('D_CREATE.deviceName'),
                prop: "deviceName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formInline.value.deviceName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceName) = $event)),
                    placeholder: _ctx.$t('D_CREATE.deviceNamePla'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "productKey",
                label: _ctx.$t('D_CREATE.productType')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    disabled: !!detailData.value.productKey,
                    modelValue: formInline.value.productKey,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.productKey) = $event)),
                    class: "ws_select_form_item",
                    onChange: productKeyChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).productGetewayType, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.code,
                          label: item.name,
                          value: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "siteId",
                label: _ctx.$t('D_INFO.belogingSite')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formInline.value.siteId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.siteId) = $event)),
                    clearable: "",
                    filterable: "",
                    class: "ws_select_form_item"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siteTreeList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('D_CREATE.deviceSn'),
                prop: "deviceSn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formInline.value.deviceSn,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.deviceSn) = $event)),
                    disabled: !!_unref(deviceBindId),
                    placeholder: _ctx.$t('D_CREATE.deviceSnPla'),
                    clearable: ""
                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_unref(showSubDevice))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    style: {"width":"500px"},
                    label: _ctx.$t('D_CREATE.subDevice'),
                    prop: "subDevices"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('D_CREATE.relativeSubNum', {
                text: formInline.value.subDevices.length,
              })), 1),
                      _createVNode(_component_el_button, {
                        onClick: toHandSubDevice,
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.relativeSub')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_unref(devicelabelShow))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: _ctx.$t('D_INFO.deviceLabel'),
                    prop: "deviceLabel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        disabled: !!detailData.value.deviceLabel,
                        modelValue: formInline.value.deviceLabel,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInline.value.deviceLabel) = $event)),
                        clearable: "",
                        maxLength: "20"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('D_CREATE.deviceConfig')), 1),
          _createVNode(_component_el_form, {
            ref_key: "confFormRef",
            ref: confFormRef,
            model: formInline.value,
            "label-width": 82,
            "label-position": "left",
            "hide-required-asterisk": "",
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('D_CREATE.labelData')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: formInline.value.dataTypeCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInline.value.dataTypeCode) = $event)),
                    prop: "dataTypeCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        style: {"width":"100px"},
                        label: _unref(DEVICE_DATA_UPLOAD_ENUM).PROPERTIES,
                        class: "radio-align"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.varTempalte')), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_DATA_UPLOAD_ENUM).UNRESOLVED
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.dataUnresolve')), 1)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('D_CREATE.deviceLocation')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: formInline.value.locationTypeCode,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formInline.value.locationTypeCode) = $event)),
                    prop: "locationTypeCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        style: {"width":"100px"},
                        label: _unref(DEVICE_LOCATION_TYPE_ENUM).AUTO,
                        class: "radio-align"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.autoLocation')), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_LOCATION_TYPE_ENUM).HAND
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.handLocation')), 1)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('D_INFO.deviceIcon'),
                prop: "picCode"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(iconList, (i) => {
                      return _createElementVNode("i", {
                        class: _normalizeClass(getClass(i)),
                        key: i,
                        onClick: ($event: any) => (changePicCode(i))
                      }, null, 10, _hoisted_9)
                    }), 64))
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              (
              formInline.value.locationTypeCode === _unref(DEVICE_LOCATION_TYPE_ENUM).HAND
            )
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t('D_CREATE.deviceMap'),
                    error: "",
                    prop: "address"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(mapData.value.address || 'lat :' + mapData.value.lat + ' lng:' + mapData.value.lng), 1),
                      _createVNode(_component_el_button, {
                        plain: "",
                        onClick: toShowMap,
                        class: "search"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.map')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: submit,
            loading: loading.value,
            class: "ws_mr16",
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.btnSave')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            plain: "",
            onClick: cancel,
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_CREATE.btnCancel')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_unref(MapModal), {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapData.value,
      onOnMapChange: onMapChange
    }, null, 8, ["visible", "data"]),
    _createVNode(SubDeviceForm, {
      visible: subDeviceConf.value.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((subDeviceConf.value.visible) = $event)),
      data: subDeviceConf.value.data,
      productType: _unref(productType),
      onOnChange: onSubDeviceChange
    }, null, 8, ["visible", "data", "productType"])
  ], 64))
}
}

})